import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormErrorsDebugService } from '../../../services/form-errors-debug.service';

@Component({
    selector: 'app-form-errors-debug',
    templateUrl: './form-errors-debug.component.html',
    styleUrls: ['./form-errors-debug.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorsDebugComponent {
    readonly MODAL_ID = FormErrorsDebugService.MODAL_ID;

    constructor(public debug: FormErrorsDebugService) {}
}
